import React from 'react';
import ReactDOM from 'react-dom';
import './styles/Index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import configureStore from './Redux/Store/configureStore';
// Redux/Store/configureStore

const store = configureStore();

// import { LangES } from './Utilities/lang/LangES'

ReactDOM.render(
  <Provider {...{ store }}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
